import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { isExpanded } from 'src/app/shared/animations/expand.animations';
import { ICON_CHEVRON_UP, ICON_CLOSE } from 'src/app/shared/named-icons.config';

@Component({
  selector: 'app-tasks-queue-card',
  templateUrl: 'tasks-queue-card.component.html',
  styleUrls: ['tasks-queue-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    InlineSVGModule,
    NgIf,
  ],
  animations: [
    isExpanded,
  ],
})
export class TasksQueueCardComponent {
  @Input()
  public progress: number | null = null;

  @Output()
  public readonly closeCard: EventEmitter<void> = new EventEmitter();

  public readonly ICON_CLOSE = ICON_CLOSE;
  public readonly ICON_CHEVRON_UP = ICON_CHEVRON_UP;

  public isExpandedBody: boolean = true;

  public get hasProgressBar(): boolean {
    return this.progress !== null;
  }

  public get progressBarWidth(): string {
    return `${this.progress}%`;
  }

  public onClickToggle(): void {
    this.isExpandedBody = !this.isExpandedBody;
  }

}
